
import React from 'react';
import Rating from '@material-ui/lab/Rating';
import StarBorderIcon from '@material-ui/icons/StarBorder';
import { makeStyles } from '@material-ui/core/styles';
import {Grid , Paper , Divider, TextField} from '@material-ui/core';

const useStyles = makeStyles({
    root: {
    flexGrow: 1,
  },
    greytypo: {
       color: '#888888' ,
       fontSize :'12px'
     },
     nametypo: {
         color: '#000000' ,
         fontSize :'18px'
       },
     blacktypo: {
         color: '#000000' ,
         fontSize :'12px'
       },
     redtypo: {
         color: '#ff6a6a' ,
         fontSize :'12px'
       },
    grid: {
        paddingTop : '15px' ,
        paddingBottom : '15px'
    } ,
    grid1: {
        paddingTop : '20px' ,
        paddingBottom : '20px'
    },
    paper: {
        paddingLeft : '20px',
        paddingRight : '20px',
        textAlign: 'left',
        height : '120px'
      },
   });


const ReviewCard = ({record }) => {

    const classes = useStyles();
        
    return (

    <React.Fragment>
        {/* 리뷰 정보 */}
        
        <Grid item lg={3}>
            <Paper className ={classes.paper}>
                <div className={classes.grid1}>
                <div >
                    <span className={classes.blacktypo}>{record.date}</span> &nbsp;&nbsp;
                    <span className={classes.greytypo}>메뉴</span>
                </div>
                <div>
                    <span className={classes.blacktypo}><b>{record.supplierName}</b></span>&nbsp;&nbsp;
                    <span className={classes.redtypo}>{record.menuName}</span>&nbsp;&nbsp;
                </div>
                <div className={classes.blacktypo}>
                    <span>
                        <Rating readOnly
                                name="customized-empty"
                                size="small"
                                defaultValue={record.ratingUser}
                                precision={0.1}
                                emptyIcon={<StarBorderIcon fontSize="inherit" />}
                        /> &nbsp;&nbsp;
                    </span>
                    <span>평점 <b>{record.ratingUser}</b></span>
                </div>
                </div>
            </Paper>
        </Grid>
        <Grid item lg={9}>
            <Paper className ={classes.paper}>
                <div className={classes.grid1}>
                <div className={classes.greytypo}>공급자에게 전해주세요.</div>
                <div>
                    <TextField readOnly fullWidth multiline defaultValue={record.review} variant="outlined" />
                </div>
                </div>
            </Paper>
        </Grid>
        {/* 리뷰 정보 */}
        
        {/* 리뷰 카테고리 */}
        <Grid item xs={2}>
        <Divider />
            <Paper className={classes.grid}>
            <div className={classes.blacktypo}>간이 딱 맞아요</div>
            <div>
                <span className={classes.blacktypo}><b>{record.sumReviewCode1}</b></span>&nbsp;&nbsp;
                {((record.reviewCode1)== '(+ 1)' )?
                <span className={classes.redtypo}>(+1)</span>
                :
                <span className={classes.redtypo}></span>
                }
            </div>
            </Paper>
        </Grid>
        <Grid item xs={2}>
        <Divider />
        <Paper className={classes.grid}>
            <div className={classes.blacktypo}>비주얼이 좋아요</div>
            <div>
                <span className={classes.blacktypo}><b>{record.sumReviewCode2}</b></span>&nbsp;&nbsp;
                {((record.reviewCode2)== '(+ 1)' )?
                <span className={classes.redtypo}>(+1)</span>
                :
                <span className={classes.redtypo}></span>
                }
            </div>
        </Paper >
        </Grid>
        <Grid item xs={2}>
        <Divider />
        <Paper className={classes.grid}>
            <div className={classes.blacktypo}>간편해서 좋아요</div>
            <div>
                <span className={classes.blacktypo}><b>{record.sumReviewCode3}</b></span>&nbsp;&nbsp;
                {((record.reviewCode3)== '(+ 1)' )?
                <span className={classes.redtypo}>(+1)</span>
                :
                <span className={classes.redtypo}></span>
                }
            </div>
        </Paper>
        </Grid>
        <Grid item xs={2}>
        <Divider />
        <Paper className={classes.grid}>
            <div className={classes.blacktypo}>양이 적당해요</div>
            <div>
                <span className={classes.blacktypo}><b>{record.sumReviewCode4}</b></span>&nbsp;&nbsp;
                {((record.reviewCode4)== '(+ 1)' )?
                <span className={classes.redtypo}>(+1)</span>
                :
                <span className={classes.redtypo}></span>
                }
            </div>
        </Paper>
        </Grid>
        <Grid item xs={2}>
        <Divider />
        <Paper className={classes.grid}>
            <div className={classes.blacktypo}>건강해서 좋아요</div>
            <div>
                <span className={classes.blacktypo}><b>{record.sumReviewCode5}</b></span>&nbsp;&nbsp;
                {((record.reviewCode5)== '(+ 1)' )?
                <span className={classes.redtypo}>(+1)</span>
                :
                <span className={classes.redtypo}></span>
                }
            </div>
        </Paper>
        </Grid>
        <Grid item xs={2}>
        <Divider />
        <Paper className={classes.grid}>
            <div className={classes.blacktypo}>구성이 좋아요</div>
            <div>
                <span className={classes.blacktypo}><b>{record.sumReviewCode6}</b></span>&nbsp;&nbsp;
                {((record.reviewCode6)== '(+ 1)' )?
                <span className={classes.redtypo}>(+1)</span>
                :
                <span className={classes.redtypo}></span>
                }
            </div>
        </Paper>
        </Grid>
        {/* 리뷰 카테고리 */}
    </React.Fragment>
    ) 
    };
    
export default ReviewCard;